import React from 'react';
import RenderDesktopCalculator from './RenderDesktopCalculator';
//import Calculator from './../../Sections/CalculatorsSection/Calculator';
import imgSrc from '../../Assets/img/misc/commingSoonCalculator.png';
import Close from '@material-ui/icons/Close';
import './main.css';
function Intermediate(props) {
  // const [showModal, setShowModal] = useState(true);
  return (
    <div className="blogdiv" style={{ overflow: 'auto' }}>
      <div className=" withfilter" style={{ display: 'flex' }}>
        <Close
          onClick={() => {
            props.onCloseCalculator();
          }}
        />
        <h2>
          {props.serviceTitle} <span>{props.serviceId}/12</span>
        </h2>
      </div>
      {props.calculators.length === 0 ? (
        <div className="calculator-not-available">
          <img src={imgSrc} alt="Calculator not enabled" />
          <p style={{ textAlign: 'left' }}>
            The calculator will be enabled shortly. In the meantime if you have
            any questions about life insurance then please reach out over phone
            or email
          </p>
        </div>
      ) : (
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {props.calculators.map((calc, index) => (
            <RenderDesktopCalculator
              calculator={calc}
              key={`${calc.name}_${index}`}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default Intermediate;
